cloneDataView